<div
  *ngIf="!this.numberOfCartLines"
  class="cart-empty-page"
>
  <div class="cart-empty-content">
    <img
      class="cart-back-empty"
      (click)="this.back()"
      src="/assets/images/shared/back.svg"
      alt=""
    />

    <h2 class="cart-empty-title">
      {{ 'Количка (' + this.numberOfCartLines + ')' }}
    </h2>

    <img
      src="/assets/images/orders/empty-cart.svg"
      alt=""
      class="cart-empty-image"
    />

    <p class="cart-empty-heading">Количката е празна</p>

    <p class="cart-empty-text">
      Започни да пазаруваш и се възползвай от <br />
      нашите отстъпки!
    </p>

    <button
      (click)="this.goToCategories()"
      type="button"
      class="btn btn-primary cart-empty-btn"
    >
      Виж продуктите
    </button>
  </div>
</div>

<div *ngIf="this.numberOfCartLines" class="cart-page">
  <div class="cart-scroll-content">
    <div class="cart-header">
      <img
        class="cart-back"
        (click)="this.back()"
        src="/assets/images/shared/back.svg"
        alt=""
      />

      <h2 class="cart-title">
        {{ 'Количка (' + this.numberOfCartLines + ')' }}
      </h2>
    </div>

    <div>
      <div *ngFor="let orgs of this.allOrgs">
        <div
          *ngIf="this.cartLinePerOrganisation[orgs].length"
          class="cart-org-card"
        >
          <div
            class="cart-product-wrapper"
            *ngFor="let productPerOrg of this.cartLinePerOrganisation[orgs]"
          >
            <div
              [matBadge]="productPerOrg.sku.product.is_in_group ? 'Групова поръчка' : ''"
              matBadgeColor="warn"
              matBadgePosition="before"
              class="row cart-product-row"
            >
              <label
                class="cart-product-image-box"
                [for]="productPerOrg.uuid"
              >
                <img
                  class="cart-product-image"
                  [src]="productPerOrg.imageSource"
                  alt=""
                />
              </label>

              <div class="col-7 cart-product-main">
                <p
                  (click)="this.goToProduct(productPerOrg)"
                  class="cart-product-name"
                >
                  {{ productPerOrg.sku.product.name }}
                </p>

                <p *ngIf="productPerOrg.sku.options.length" class="cart-product-options">
                  <span *ngFor="let option of productPerOrg.sku.options; index as i">
                    {{
                      option.option.display_name + ': ' + option.valueDecoded +
                      ((i != productPerOrg.sku.options.length - 1) ? ' | ' : '')
                    }}
                  </span>
                </p>

                <p *ngIf="!productPerOrg.sku.options.length" class="cart-product-options">&nbsp;</p>

                <p
                  *ngIf="!this.isProductAvailable(productPerOrg)"
                  class="cart-product-unavailable"
                >
                  <span>Изчерпан</span>
                </p>

                <div *ngIf="this.isProductAvailable(productPerOrg)" class="cart-product-price-block">
                  <div class="cart-item-row">
                    <div class="cart-item-info">
                      <app-price
                        class="cart-line-total-price"
                        [amount]="getLineTotalBase(productPerOrg)"
                        layout="inline"
                      ></app-price>

                      <div class="cart-item-subprice">
                        <span class="cart-line-mult">{{ pricingInfoText(productPerOrg) }}</span>
                        <app-price
                          class="cart-line-unit-price"
                          [amount]="getUnitPriceBase(productPerOrg)"
                          layout="inline"
                        ></app-price>
                      </div>
                    </div>

                    <div class="cart-item-qty">
                      <img
                        class="qty-btn"
                        [class.btnDsbld]="productPerOrg.quantity == 1"
                        (click)="decreaseAmount(productPerOrg, orgs)"
                        src="/assets/images/product/minus.svg"
                        alt=""
                      />

                      <span class="qty-value">{{ productPerOrg.quantity }}</span>

                      <img
                        class="qty-btn"
                        [class.btnDsbld]="isIncreaseBtnDisabled(productPerOrg)"
                        (click)="increaseAmount(productPerOrg)"
                        src="/assets/images/product/plus.svg"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>

              <img
                (click)="this.removeLine(productPerOrg, orgs)"
                class="cart-remove-btn"
                src="/assets/images/orders/remove.svg"
                alt=""
              />
            </div>

            <hr class="cart-product-divider" />
          </div>

          <div class="row cart-org-total-row">
            <p class="col-6 cart-org-total-label">
              {{ 'Общо за ' + this.cartLinePerOrganisation[orgs][0]?.sku?.product?.organisation?.native_name + ':' }}
            </p>

            <div class="col-6 cart-org-total-value">
              <app-price
                class="cart-org-total-price"
                [amount]="getOrgTotalBase(orgs)"
                layout="inline"
              ></app-price>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  *ngIf="this.cart && this.cart.lines.length"
  class="cart-bottom-bar"
>
  <div class="row cart-bottom-inner">
    <div class="col-6 cart-bottom-summary">
      <div class="cart-bottom-total">
        <span>Общо: </span>
        <app-price
          class="cart-grand-total-price"
          [amount]="totalSelectedBase"
          layout="inline"
        ></app-price>
        <span>*</span>
      </div>

      <p class="cart-bottom-note">
        *Цената за доставка ще се изчисли на <br />
        следващата стъпка
      </p>
    </div>

    <div class="col-6 cart-bottom-action">
      <button
        type="button"
        class="btn btn-primary cart-continue-btn"
        (click)="this.createOrder()"
      >
        Продължи
      </button>
    </div>
  </div>
</div>
